export function validEmail (email) {
  if (!email) {
    return false
  }
  return /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((?!.*\.\.)((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))$)/.test(email)
}

export function getEmailRepetition (emailKey) {
  switch (emailKey) {
    case 'matching_volunteer_with_vacancies':
      return '30_days'
    case 'matching_organisation_with_volunteers':
      return '14_days'
    case 'organisation_inactivity_mail':
      return '12_months'
    case 'todo_summary_for_user':
      return 'sixth_day_of_month'
    case 'todo_summary_for_organisation':
      return 'eight_day_of_month'
    default:
      return null
  }
}

export function convertComposedEmailToFormData (composedEmail) {
  let formData = new FormData()
  formData.append('email', JSON.stringify(composedEmail.email))
  if (composedEmail.attachments) {
    for (let i = 0; i < composedEmail.attachments.length; i++) {
      formData.append(`attachment_${i}`, composedEmail.attachments[i])
    }
  }
  if (composedEmail.optionalVacancy) {
    formData.append('optionalVacancy', JSON.stringify(composedEmail.optionalVacancy))
  }
  return formData
}
